/**
 * Request validation utilities
 */

import { DurinValidationError } from './errors';
import { TranslateParams, RewriteParams, SummarizeParams } from '../types';

export function validatePrompt(prompt: string): void {
  if (!prompt || typeof prompt !== 'string') {
    throw new DurinValidationError('Prompt must be a non-empty string');
  }
  
  if (prompt.trim().length === 0) {
    throw new DurinValidationError('Prompt cannot be empty or only whitespace');
  }
}

export function validateMaxTokens(maxTokens?: number): void {
  if (maxTokens !== undefined) {
    if (!Number.isInteger(maxTokens) || maxTokens <= 0) {
      throw new DurinValidationError('maxTokens must be a positive integer');
    }
    // Let the backend service validate against the specific model's limits
  }
}

export function validateModelId(modelId?: string): void {
  if (modelId !== undefined && (typeof modelId !== 'string' || modelId.trim().length === 0)) {
    throw new DurinValidationError('modelId must be a non-empty string');
  }
}

export function validateTranslateParams(params: TranslateParams): void {
  if (!params.targetLanguage || typeof params.targetLanguage !== 'string') {
    throw new DurinValidationError('targetLanguage is required and must be a string');
  }
  
  if (params.targetLanguage.trim().length === 0) {
    throw new DurinValidationError('targetLanguage cannot be empty');
  }
  
  // sourceLanguage is optional - backend defaults to "auto" for automatic detection
  if (params.sourceLanguage !== undefined) {
    if (typeof params.sourceLanguage !== 'string' || params.sourceLanguage.trim().length === 0) {
      throw new DurinValidationError('sourceLanguage must be a non-empty string when provided');
    }
  }
}

export function validateRewriteParams(params: RewriteParams): void {
  const validTones = ['friendly', 'professional', 'concise'];
  
  if (!params.tone) {
    throw new DurinValidationError('tone is required');
  }
  
  if (!validTones.includes(params.tone)) {
    throw new DurinValidationError(`tone must be one of: ${validTones.join(', ')}`);
  }
}

export function validateSummarizeParams(params: SummarizeParams): void {
  const validLengths = ['brief', 'standard', 'detailed'];
  const validFormats = ['paragraph', 'bullets', 'numbered'];
  
  if (!params.length) {
    throw new DurinValidationError('length is required');
  }
  
  if (!validLengths.includes(params.length)) {
    throw new DurinValidationError(`length must be one of: ${validLengths.join(', ')}`);
  }
  
  if (params.format !== undefined && !validFormats.includes(params.format)) {
    throw new DurinValidationError(`format must be one of: ${validFormats.join(', ')}`);
  }
}